import {
  defineStyle,
  defineStyleConfig,
  createMultiStyleConfigHelpers,
} from '@chakra-ui/react';
import { formAnatomy, formErrorAnatomy } from '@chakra-ui/anatomy';
import { getTypographyToken } from '@allergan-data-labs/alle-elements-core';

const {
  definePartsStyle: defineFormPartsStyle,
  defineMultiStyleConfig: defineFormMultiStyleConfig,
} = createMultiStyleConfigHelpers(formAnatomy.keys);
const {
  definePartsStyle: defineFormErrorPartsStyle,
  defineMultiStyleConfig: defineFormErrorMultiStyleConfig,
} = createMultiStyleConfigHelpers(formErrorAnatomy.keys);

export const FormTheme = defineFormMultiStyleConfig({
  baseStyle: defineFormPartsStyle((props) => {
    /* 
      The colorScheme value is populated by the colorMode prop. Had to do it
      this way because we cannot extend the chakra-ui component props and
      we kept getting an error for using custom props on a chakra component.
      Keep in mind that not all of our themed library components require
      this method. We also could not use the colorScheme property for our color
      mode changes because certain components, like button, was already using
      the colorScheme property.
    */
    const { isDisabled, colorScheme } = props;
    return {
      container: {
        width: '100%',
        position: 'relative',
      },
      requiredIndicator: {},
      helperText: {
        marginTop: '10',
        color: `${colorScheme}.Text/Neutral/Placeholder`,
        ...getTypographyToken('Body/Small/Regular'),
        ...(isDisabled && {
          opacity: 1,
          color: `${colorScheme}.Text/Neutral/Disabled/Default`,
        }),
      },
    };
  }),
});

export const FormLabelTheme = defineStyleConfig({
  baseStyle: defineStyle((props) => {
    /**
     * We don't need to look for colorScheme here since the colorMode prop
     * is automatically provided to the FormError component via a provider
     * and not via the DOM which suppresses the DOM error we get when using
     * `colorMode="<value>" on a chakra-ui component
     */
    const { colorMode } = props;
    return {
      marginBottom: '8',
      marginRight: 0,
      color: `${colorMode}.Text/Neutral/Default`,
      ...getTypographyToken('Body/Medium/Medium'),
      _disabled: {
        opacity: 1,
        color: `${colorMode}.Text/Neutral/Disabled/Default`,
      },
      display: 'flex',
    };
  }),
});

export const FormErrorTheme = defineFormErrorMultiStyleConfig({
  baseStyle: defineFormErrorPartsStyle((props) => {
    /**
     * We don't need to look for colorScheme here since the colorMode prop
     * is automatically provided to the FormError component via a provider
     * and not via the DOM which suppresses the DOM error we get when using
     * `colorMode="<value>" on a chakra-ui component
     */
    const { colorMode } = props;
    return {
      text: {
        marginTop: '10',
        color: `${colorMode}.Text/Status/Error medium 3`,
        ...getTypographyToken('Body/Small/Regular'),
      },
      icon: {},
    };
  }),
});
